export default __webpack_public_path__ + "static/media/winter-intro-background.bb0c2893.png";